var _path, _circle, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSilver1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 116,
    viewBox: "0 0 71 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.5 1.5H57.5L41 49L48.5 52L65.5 1.5Z",
    fill: "#B9BABC",
    stroke: "#B9BABC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 80,
    r: 35,
    fill: "#B9BABC",
    stroke: "#B9BABC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 1H5.5L22 48.5L29.5 46.5L14 1Z",
    fill: "#B9BABC",
    stroke: "#B9BABC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 1.5H40.5L26 45.5L33 47.5L48.5 1.5Z",
    fill: "#B9BABC",
    stroke: "#B9BABC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 1H23L32.5 31L38 20.5L31.5 1Z",
    fill: "#B9BABC",
    stroke: "#B9BABC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8906 96H33.3047V71.1797C30.8984 73.4297 28.0625 75.0938 24.7969 76.1719V70.1953C26.5156 69.6328 28.3828 68.5703 30.3984 67.0078C32.4141 65.4297 33.7969 63.5938 34.5469 61.5H39.8906V96Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilver1);
export default __webpack_public_path__ + "static/media/silver_1.b3d00370c9e387449d3fe0aa5e510402.svg";
export { ForwardRef as ReactComponent };